<ion-app>
  <app-side-menu></app-side-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
